"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _icon = _interopRequireDefault(require("./icon"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var IconButton = function IconButton(props) {
  var onClick = props.onClick,
      icon = props.icon,
      tooltip = props.tooltip;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      hovered = _useState2[0],
      setHovered = _useState2[1]; // NOTE: using Tooltips when we have 100 more items leads to a significant latency. We sidestep
  // this by only loading the tooltip on the initial mouse over.


  var button = /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    onClick: onClick,
    onMouseEnter: function onMouseEnter() {
      return setHovered(true);
    },
    "aria-label": props['aria-label']
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    icon: icon
  }));

  if (hovered && tooltip) {
    return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
      title: tooltip
    }, button);
  } else {
    return button;
  }
};

var _default = IconButton;
exports.default = _default;